import { render, staticRenderFns } from "./BannerAds.vue?vue&type=template&id=2b3b6b60&scoped=true&"
import script from "./BannerAds.vue?vue&type=script&lang=js&"
export * from "./BannerAds.vue?vue&type=script&lang=js&"
import style0 from "./BannerAds.vue?vue&type=style&index=0&id=2b3b6b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b6b60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
